// extracted by mini-css-extract-plugin
export default {"actionsContainer":"InlineTableActions_actionsContainer__M+eYT"};